const selectors = {
    readMoreBtn: document.querySelector('[data-readMoreBtn]'),
    readMoreContainer: document.querySelector('[data-readMoreContainer]'),
  };

class templateCollectionJS {
  constructor() {
    this.readMore();
  }

  readMore(){
    if(selectors.readMoreBtn){
      selectors.readMoreBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        const currentTarget = e.target;
        const readMoreEle = selectors.readMoreContainer.querySelector('.hidden-text');
        if(readMoreEle){ 
          if(selectors.readMoreContainer.classList.contains('open')){
            Utility.toggleElement(selectors.readMoreContainer, 'close');
            currentTarget.innerHTML = 'Read More'
          }else{
            Utility.toggleElement(selectors.readMoreContainer, 'open');
            currentTarget.innerHTML = 'Read Less'
          }
        }
      });
    }
  }
}

window.onload = () => {
  typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();
}
